export default "__VITE_ASSET__b6aa4107__"